import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateVoucherRequestDTO, RequestVoucherResponse } from "@/types";
import { httpRequest } from "@/lib";

async function createVoucher(
  request: CreateVoucherRequestDTO
): Promise<RequestVoucherResponse> {
  const response = await httpRequest.post<RequestVoucherResponse>(
    `/vouchers`,
    request
  );
  return response.data;
}

export function useCreateVoucherMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createVoucher,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vouchers"] });
    },
  });
}
